<template>
  <div class="new">
    <el-row :gutter="24" style="margin:0;">
      <el-col :span="14" :offset="5" v-if="datanew">
        <p class="new-title" ref='out'><img src="../assets/img/left.png" alt=""> {{datanew.title}}</p>
        <p class="new-title2"><span>{{datanew.type==1?'行业新闻':'公司新闻'}}</span> <span>{{datanew.time}}</span> </p>
        <!-- <div class="imgs">
        <img v-if="id==6" src="../assets/img/image/图片1.png" alt="">
        <img v-if="id==6" src="../assets/img/image/图片2.png" alt="">
        <img v-if="id==7" src="../assets/img/image/图片3.png" alt="">
        <img v-if="id==7" src="../assets/img/image/图片4.png" alt="">
        <img v-if="id==7" src="../assets/img/image/图片5.png" alt="">
        <img v-if="id==8" src="../assets/img/image/图片6.png" alt="">
        <img v-if="id==8" src="../assets/img/image/图片7.png" alt="">
        <img v-if="id==8" src="../assets/img/image/图片8.png" alt="">
        <img v-if="id==9" src="../assets/img/image/图片15.png" alt="">
        <img v-if="id==10" src="../assets/img/image/图片16.png" alt="">
        <img v-if="id==11" src="../assets/img/image/图片17.png" alt="">
        <img v-if="id==11" src="../assets/img/image/图片18.png" alt="">
        <img v-if="id==12" src="../assets/img/image/图片19.png" alt="">

        <img v-if="id==13" src="../assets/img/image/图片21.png" alt="">
        <img v-if="id==13" src="../assets/img/image/图片20.png" alt="">

        <img v-if="id==14" src="../assets/img/image/图片22.png" alt="">
        <img v-if="id==15" src="../assets/img/image/图片23.png" alt="">
        <img v-if="id==0" src="../assets/img/image/0.gif" alt="">
        <img v-if="id==0" src="../assets/img/image/641 (1).webp" alt="">
        <img v-if="id==0" src="../assets/img/image/641 (2).webp" alt="">
        <img v-if="id==0" src="../assets/img/image/641 (3).webp" alt="">
      </div> -->

        <div style="margin-left:40px;margin-right:20px;">
          <div  v-html="datanew.content">
          </div>
        </div>
         <span class="new-span" v-if="datanew.prev.title" @click="send(0)">上一篇：{{datanew.prev.title}}</span>
         <span class="new-span" v-if="datanew.next.title"  @click="send(1)">下一篇：{{datanew.next.title}}</span>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import lxapi from '../api/api'
export default {
  name: "product",
  data () {
    return {
      lis:[
        {text:'行业新闻',id:1},
        {text:'公司新闻',id:2}
      ],
      datanew:{
        prev:{
          title:'',
        },
        next:{
          title:'',
        }
      },


    };
  },
  watch: {
    $route(to, from) {
        if (to,from) {
          this.getlist()
          this.setheight()
        }
      },
    },

  created() {
    this.getlist()


  },
  mounted () {
    this.setheight()
    },
   methods:{
    setheight(){
      var element=this.$refs.out
      if (element) {
        setTimeout(() => {
          const rect = element.getBoundingClientRect();
        const distanceToTop = rect.top + window.scrollY; // 计算距离顶部的距离
        console.log(distanceToTop,9999)
        this.$bus.$emit("clearKeyword",distanceToTop);
        }, 500);
      }
    },
    getlist() {
      this.id=this.$route.query.id
     lxapi.getli(this.id).then(res=>{
      this.datanew=res.data
     }).catch(err=>{
      console.log(err)
     })
    },
    send(item){
      this.$router.replace({path:'/new',query:{id:item==1?this.datanew.next.id:this.datanew.prev.id}})
    }


   },
  components: {

  }
};
</script>
<style lang="scss" scoped>
.new{
  .imgs{
    img{
      width:100%;
      margin-bottom: 20px;
    }
  }
  img{
    width:100%;
  }
  .news-head-table{
    height:80px;
    line-height: 80px;
   background: #ffffff;
   color:#676767;
   margin-top:-45px;
   border-radius: 50px 0 50px 0;
   box-shadow:0px 0px 5px 5px #ccc;
   font-size:18px;
   display: flex;
   li{
    flex:1;
    text-align: center;
    .news-head-table-check{
      color:#0152a1;
      padding-bottom:20px;
      border-bottom: 4px solid #0152a1;
    }
   }
  }


 .new-title{
   font-size: 28px;
   margin-top:50px;
   img{
      width:20px;
    vertical-align: middle;
   }
 }

 .new-title2{
  padding-left:40px;
  margin-top:20px;
  margin-bottom: 50px;
  color:#999999;
  span:nth-child(1){
    margin-right:10px;
    padding:5px 10px;
    background: #e6e9ec;
    color:#707172;
  }
 }
 .new-head{
  background: #e6e9ec;
  padding:20px 40px;
  margin-top:20px;
  p:nth-child(1){
    display: inline-block;
    padding:5px 30px;
    background: #00529f;
    color:white;
  }
  p{
    margin-bottom: 10px;
    color:#333333;
  }
 }
 .new-head-text{
  text-indent: 2em;
  padding:10px 40px;
 }
 .new-span{
  width:60%;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;

  cursor: pointer;
  margin-top:20px;
  display: block;
  color:#666666;
 }
}
@media only screen and (max-width: 767px) {

}
</style>
<style >

</style>
